import { render, staticRenderFns } from "./VerifikasiCode.vue?vue&type=template&id=64946a37"
import script from "./VerifikasiCode.vue?vue&type=script&lang=js"
export * from "./VerifikasiCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports